import React, { useEffect, useState } from 'react'
import request from '../../../../utils/request';
import EmployeeListItem from './EmployeeListItem';
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import { selectDataListSectionIds, selectEndorsmentScreenNumber } from 'src/features/rfqDataSlice';
import AddNewHeaderBox from '../AddNewHeaderBox';
import { Settings } from "@mui/icons-material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddCircleIcon from '@mui/icons-material/AddCircle';


function EmployeeList({ sumInsuredData, productId }) {
  const [employeeGroups, setEmployeeGroups] = useState([]);

  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);
  const [openAddNewHeaderBox, setOpenAddNewHeaderBox] = useState(false);
  const sectionId = sumInsuredData?.id;
  const [anchorEl, setAnchorEl] = useState(null);
  const closeAddNewHeaderBox = () => {
    setOpenAddNewHeaderBox(false);
  }
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    fetchEmpGroups();
  }, [])

  const fetchEmpGroups = () => {

    request({
      url: '/insurancePolicy/getSumInsuredListGroups',
      method: 'post',
      data: {
        policyId: sumInsuredData.policyId,
        sectionId: sumInsuredData.id
      }
    }).then(
      (response: any) => {
        setEmployeeGroups(response.data);
        if (response.data.length > 0) {
          let sumInsuredBox = document.getElementById('sumInsuredBox');
          if (sumInsuredBox) { sumInsuredBox.style.display = 'block' }
        }

      },
      (error) => {
        console.log(error);

      }
    );
  }



  const showSectionDataList = useSelector(selectDataListSectionIds);
  return (
    <>
    
      {employeeGroups.length > 0 && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            mt: "10px",
            mb: "5px",
            p: "6px",
            background: "rgb(9, 84, 174)",
            color: "#fff",
            borderRadius: "4px",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            className="heading"
            component="div"
            sx={{ fontWeight: "bold" }}
          >
            {sumInsuredData?.sectionName} 
          </Typography>
          {endorsementScreenNumber == 1 && <>
            <IconButton onClick={handleOpenMenu} sx={{ color: "#fff", padding: 0 }}>
              <Settings />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                key={'add_headers'}
                onClick={() => {
                  setOpenAddNewHeaderBox(true);
                  handleCloseMenu();
                }}
              >
                <ListItemIcon>
                  <AddCircleIcon/>
                </ListItemIcon>
                <ListItemText style={{ display: 'flex', justifyContent: 'flex-start' }} >Add Headers</ListItemText>
                
              </MenuItem>
              
            </Menu>
          </>}


        </Box>
      )}




      {
        employeeGroups.length > 0 &&
        employeeGroups.map((group) => (
          <EmployeeListItem
            key={group.id}
            sumInsuredData={sumInsuredData}
            groupDetails={group}
            policyId={sumInsuredData.policyId}
            productId={productId}
          />
        ))
      }

      {openAddNewHeaderBox && <AddNewHeaderBox sumInsuredData={sumInsuredData} onClose={closeAddNewHeaderBox} />}

    </>
  )
}

export default EmployeeList